<span
  *ngIf="getCountryCode(country)"
  class="fp"
  [ngClass]="getFlag(country)"
></span>
